<template>
  <div class="video-wrap">
    <video playsinline width="640">
      <source src="/frontend/assets/videos/video.mp4" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
    <div
      id="video-trigger"
      class="paragraph--xlarge text-uppercase text-color-quinary"
    >
      PLAY
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppShowroom'
};
</script>

<style scoped>


#video-trigger {
  position: absolute;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 10px 20px;
  
  transition: all 0.3s ease;
}

#video-trigger:hover {
  background-color: rgba(0, 0, 0, 0.7);
}
</style>
